import { Card } from '@zenid/web';
import { css } from '../../../../../styled-system/css';
import { flex } from '../../../../../styled-system/patterns';
import type { ChangeFormProps } from '../ChangeForm/ChangeForm';
import { ChangeForm } from '#/features/emailChange/components/ChangeForm';

export type EmailChangeProps = ChangeFormProps;

export function EmailChange({ onSubmit, register, formState }: EmailChangeProps) {
  return (
    <Card className={css({ backgroundColor: '{colors.background.white}' })}>
      <div
        className={flex({
          padding: '{spacing.20} {spacing.20} {spacing.40} {spacing.20}',
          flexDirection: 'column',
          justifyContent: 'center',
          sm: {
            padding: '{spacing.40}',
          },
        })}
      >
        <h1
          className={css({
            textStyle: 'headding.l',
            paddingTop: '{spacing.24}',
            paddingBottom: '{spacing.16}',
            textAlign: 'center',
            color: '{colors.text.main}',
          })}
        >
          メールアドレスの変更
        </h1>
        <p className={css({ textStyle: 'body.m.default', color: '{colors.text.sub}', textAlign: 'center' })}>
          新しいメールアドレスを入力してください。
        </p>
      </div>
      <ChangeForm onSubmit={onSubmit} register={register} formState={formState} />
    </Card>
  );
}
